import React from "react";
import { List, Box, Typography } from "@mui/material";
import { NavGroup } from "./sidebarConfig";
import SidebarNavItem from "./SidebarNavItem";

interface SidebarNavGroupProps {
  group: NavGroup;
  activeSection?: string;
}

export const SidebarNavGroup: React.FC<SidebarNavGroupProps> = ({
  group,
  activeSection,
}) => {
  return (
    <>
      <Box sx={{ pt: "12px", px: "16px" }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          {group.label}
        </Typography>
      </Box>

      <List disablePadding>
        {group.items.map((item) => (
          <SidebarNavItem
            key={item.path}
            item={item}
            isActive={activeSection === item.path}
          />
        ))}
      </List>
    </>
  );
};

export default SidebarNavGroup;
